import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '../../..';
import { ContractSearchComponent, ContractSearchComponentProperties } from './contract-search.component';
import { searchContracts } from 'src/contract/contract.actions';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<ContractSearchComponentProperties> {
  return {
    message: state.contract.message,
    searchQuery: state.contract.searchQuery,
    searchLoading: state.contract.searchLoading,
    searchPageCount: state.contract.searchPageCount,
    searchPageNumber: state.contract.searchPageNumber,
    searchPageSize: state.contract.searchPageSize,
    searchResults: state.contract.searchResults,
    searchResultsTotalCount: state.contract.searchResultsTotalCount
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<ContractSearchComponentProperties> {
  return {
    searchContracts: (pageNumber, pageSize, query, orderBy, orderDirection) =>
      dispatch(searchContracts(pageNumber, pageSize, query, orderBy, orderDirection))
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const ContractSearch = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractSearchComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/contract-search/contract-search.container.tsx